/* oluxa-cart.js — AJAX cart drawer: add, change qty, remove, refresh */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 50 * 100; // in cents

  /* ── Public API ── */
  window.oxCartAdd = function (variantId, qty, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        window.oxCartRefresh();
        if (callback && data.items && data.items[0]) callback(data.items[0]);
      })
      .catch(function (err) { console.error('oxCartAdd error', err); });
  };

  window.oxCartRefresh = function () {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadge(cart.item_count);
        renderDrawer(cart);
      });
  };

  window.oxCartOpen = function () {
    window.oxCartRefresh();
    var scrim  = document.getElementById('ox-cart-scrim');
    var drawer = document.getElementById('ox-cart-drawer');
    if (scrim)  scrim.classList.add('ox-cart-scrim--open');
    if (drawer) drawer.classList.add('ox-cart-drawer--open');
    document.body.style.overflow = 'hidden';
  };

  window.oxCartClose = function () {
    var scrim  = document.getElementById('ox-cart-scrim');
    var drawer = document.getElementById('ox-cart-drawer');
    if (scrim)  scrim.classList.remove('ox-cart-scrim--open');
    if (drawer) drawer.classList.remove('ox-cart-drawer--open');
    document.body.style.overflow = '';
  };

  /* ── Badge ── */
  function updateBadge(count) {
    var badge = document.getElementById('ox-cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('ox-nav__cart-badge--visible', count > 0);
  }

  /* ── Render cart items ── */
  function renderDrawer(cart) {
    var titleEl = document.getElementById('ox-cart-title');
    var bodyEl  = document.getElementById('ox-cart-body');
    var footEl  = document.getElementById('ox-cart-foot');
    if (!bodyEl) return;

    var count = cart.item_count;

    if (titleEl) {
      titleEl.textContent = count === 0 ? 'Empty for now.' : count + (count === 1 ? ' piece.' : ' pieces.');
    }

    if (count === 0) {
      bodyEl.innerHTML =
        '<div class="ox-cart-drawer__empty">' +
        '<div class="ox-cart-drawer__empty-ital">Begin the ritual.</div>' +
        '<p class="ox-cart-drawer__empty-body">Two formulas, hand-blended in small batches. Add a piece to begin.</p>' +
        '<button class="btn-ghost" onclick="window.oxCartClose()">Continue browsing</button>' +
        '</div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }

    // Line items
    bodyEl.innerHTML = cart.items.map(function (item) {
      var imgUrl = item.image
        ? item.image.replace(/(\.[a-z]+)(\?.*)?$/, '_200x$1')
        : '';
      var linePrice = (item.line_price / 100).toFixed(2);
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return (
        '<div class="ox-cart-item" data-key="' + item.key + '">' +
          '<div class="ox-cart-item__img">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + escHtml(item.title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<div class="ox-cart-item__head">' +
              '<div class="ox-cart-item__name">' + escHtml(item.product_title) + '</div>' +
              '<div class="ox-cart-item__price">$' + linePrice + '</div>' +
            '</div>' +
            (variant ? '<div class="ox-cart-item__variant">' + escHtml(variant) + '</div>' : '') +
            '<div class="ox-cart-item__controls">' +
              '<div class="ox-cart-item__qty">' +
                '<button class="ox-cart-item__qty-btn" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease">−</button>' +
                '<span class="ox-cart-item__qty-val">' + item.quantity + '</span>' +
                '<button class="ox-cart-item__qty-btn" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<button class="ox-cart-item__remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    // Footer
    if (footEl) {
      footEl.style.display = '';
      var subtotal = cart.total_price;
      var shipping = subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : 599;
      var total    = subtotal + shipping;
      var subtotalFmt = '$' + (subtotal / 100).toFixed(2);
      var totalFmt    = '$' + (total   / 100).toFixed(2);
      footEl.innerHTML =
        '<div class="ox-cart-drawer__shipping">' +
          '<span>Shipping</span>' +
          '<span>' + (shipping === 0 ? 'Free' : '$5.99') + '</span>' +
        '</div>' +
        '<div class="ox-cart-drawer__subtotal">' +
          '<span class="ox-cart-drawer__subtotal-label">Subtotal</span>' +
          '<strong class="ox-cart-drawer__subtotal-val">' + totalFmt + '</strong>' +
        '</div>' +
        '<button class="btn-primary ox-cart-drawer__checkout" onclick="window.location.href=\'/checkout\'">Checkout · ' + totalFmt + '</button>' +
        '<p class="ox-cart-drawer__reassurance">Secure · 30-Day Returns · Free over $50</p>';
    }
  }

  /* ── Qty / remove delegation ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;
    var key    = btn.dataset.key;
    var qty    = parseInt(btn.dataset.qty, 10);

    if (action === 'inc') changeQty(key, qty + 1);
    if (action === 'dec') changeQty(key, qty - 1);
    if (action === 'remove') changeQty(key, 0);
  });

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadge(cart.item_count);
        renderDrawer(cart);
      });
  }

  /* ── Cart trigger buttons ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#ox-cart-open')) window.oxCartOpen();
    if (e.target.closest('#ox-cart-scrim')) window.oxCartClose();
    if (e.target.closest('#ox-cart-close')) window.oxCartClose();
  });

  /* ── Add-to-cart buttons on product cards ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    var vid  = parseInt(btn.dataset.addVariant, 10);
    var name = btn.dataset.addName || '';
    if (!vid) return;
    window.oxCartAdd(vid, 1, function () {
      window.oxShowToast && window.oxShowToast('Added · ' + name.replace('Oluxa ', ''));
    });
  });

  /* ── Add-the-Pair button ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-pair]');
    if (!btn) return;
    e.preventDefault();
    var ids = (btn.dataset.addPair || '').split(',').map(Number).filter(Boolean);
    if (!ids.length) return;
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function () {
        window.oxShowToast && window.oxShowToast('The Pair added to your bag');
        setTimeout(function () { window.oxCartOpen(); }, 200);
        window.oxCartRefresh();
      });
  });

  /* ── Init: refresh badge on page load ── */
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); });
  });

  /* ── Helpers ── */
  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

})();
